import React from 'react';
import imgTechnicien from '../assets/images/img-technicien.png';
import styles from './SearchSav.module.css';
import FormSearchSav from '../components/form/FormSearchSav';

export default function SearchSav (): React.ReactElement {
  return (
    <>
      <section className="hero is-overlapped">
        <div className="hero-body">
          <div className="container">
            <div className="columns is-centered">
              <div className="column is-9-widescreen is-11-tablet">
                <div className="rows">
                  <div className="row has-text-centered">
                    <h1 className="headline is-level-2">Suivi de dossier</h1>
                    <div className="notification has-body is-small is-marginless">
                      <span className="icon">
                        <i className="tri-infos-circle"
                          aria-hidden="true"></i>
                      </span>
                      <div className="body">
                        <div className="title is-level-3 is-loaded">Votre numéro de dossier SAV est indiqué dans les mails et SMS envoyés par Bouygues Telecom</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section has-background-grey-light">
        <div className="container">
          <div className="columns is-centered">
            <div className="column is-9-widescreen is-11-tablet">
              <div className="card is-horizontal is-vcentered is-reversed">
                <div className={ `card-image is-3 ${ styles.cardImage }` }>
                  <figure className="image">
                    <img src={ imgTechnicien }
                      alt="Image d'un technicien"
                      loading="lazy"/>
                  </figure>
                </div>
                <div className="card-content">
                  <div className="rows">
                    <FormSearchSav/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section has-background-white">
        <div className="container is-fluid">
          <nav className="breadcrumb"
            aria-label="breadcrumbs">
            <ul>
              <li><a href="https://www.bouyguestelecom.fr/">Accueil</a></li>
              <li><a href="https://www.assistance.bouyguestelecom.fr/s/">Assistance</a></li>
              <li><a href="https://www.assistance.bouyguestelecom.fr/s/home-sav-mobile">SAV Mobile</a></li>
              <li className="is-active"><a href="/">SAV Mobile</a></li>
            </ul>
          </nav>
        </div>
      </section>
    </>
  );
}